require('core-js/modules/es6.symbol');
require('core-js/modules/es6.array.iterator');
require('core-js/modules/es6.promise');


import Raven from 'raven-js';
Raven
    .config('https://1cfda061e666cae0afa7eede64432613@sentry.tawenda-tech.org/4', {
            release: "__VERSION__",
            whitelistUrls: [
                /straceo\.com/,
                /straceo\.domain/,
            ],
            shouldSendCallback: function(data) {

              if (data['extra'] && data['extra']['__serialized__'] && data['extra']['__serialized__']['message']) {
                return data['extra']['__serialized__']['message'].indexOf("Received invalid event") !== 0;
              }

              return true;
            }
        })
    .install();

const utils = require('./utils');
const payments = require('./payments');
const connection = require('./connection');

export { utils, payments, connection };
